import React, { useState } from "react";
import AuthCard from "../../shared/components/CustomCards";
import { CustomInput } from "../../shared/components/AllInputs";
import PrimaryButton from "../../shared/components/CustomButtons";
import { useNavigate } from "react-router-dom";
import formValidation from "../../utils/validations";
import { showFormErrors } from "../../utils/commonFunctions";
import { useDispatch } from "react-redux";
import { forgotPasswordAction } from "../../store/actions/auth.actions";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    email: "",
    otpType: 2,
  });

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data);
    setData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const handleForgotPassword = () => {
    if (showFormErrors(data, setData)) {
      dispatch(forgotPasswordAction(data, setLoading, navigate));
    }
  };

  return (
    <div className="flex justify-content-center align-items-center h-full">
      <AuthCard heading={"Forgot password?"}>
        <CustomInput
          label="Email"
          name="email"
          data={data}
          placeholder="Email"
          col={12}
          onChange={handleChange}
        />

        <PrimaryButton
          label="Reset password"
          extraClassNames="w-full mt-3"
          onClick={handleForgotPassword}
          loading={loading}
        />
      </AuthCard>
    </div>
  );
}
